import React from 'react';

import Modal from '../modal';
import DistanceForm from './distance-form';


export default function DistanceFormModal(props) {

    const {isOpen, ...restprops} = props

    return (
         <Modal className="modal big-modal" isOpen={isOpen}>
            <div className="modal-content">
                <DistanceForm {...restprops} />
            </div>
        </Modal>
    );
}



// WEBPACK FOOTER //
// ./src/js/components/stage/distance-modal.js